module.exports = __webpack_public_path__ + "img/Igbhc-logo.01f98c75.png";